import { render, staticRenderFns } from "./info-detail.vue?vue&type=template&id=1f051c3c&scoped=true&"
import script from "./info-detail.vue?vue&type=script&lang=js&"
export * from "./info-detail.vue?vue&type=script&lang=js&"
import style0 from "./info-detail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./info-detail.vue?vue&type=style&index=1&id=1f051c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f051c3c",
  null
  
)

export default component.exports